import { ReactNode, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";
import { Loader2 } from "lucide-react";

/** Allows access if user is admin OR an owner/admin of any organization. */
export default function RequireOrgManager({ children }: { children: ReactNode }) {
  const { user, hasRole, isLoading } = useAuth();
  const [checking, setChecking] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    if (isLoading) return;
    if (!user) { setChecking(false); return; }
    if (hasRole("admin")) { setAllowed(true); setChecking(false); return; }
    (async () => {
      const { data } = await supabase
        .from("organization_members")
        .select("id")
        .eq("user_id", user.id)
        .in("role", ["owner", "admin"])
        .limit(1);
      setAllowed((data ?? []).length > 0);
      setChecking(false);
    })();
  }, [user?.id, isLoading]);

  if (isLoading || checking) {
    return <div className="container py-12"><Loader2 className="w-5 h-5 animate-spin" /></div>;
  }
  if (!user) return <Navigate to="/login/studio" replace />;
  if (!allowed) return <Navigate to="/login/studio" replace />;
  return <>{children}</>;
}